<button (click)="switchMapTypeClick(EMapType.ROADMAP)"
  [class.map-type-switcher-btn--selected]="mapType === EMapType.ROADMAP"
  class="btn map-type-switcher-btn"
  i18n-fmTooltip="@@S_DEFAULT"
  fmTooltip="Default"
  a7s-id="live-map-options-default">
  <span class="map-type-switcher__text"
    i18n="@@S_DEFAULT">Default</span>
</button>
<button (click)="switchMapTypeClick(EMapType.SATURATED)"
  [class.map-type-switcher-btn--selected]="mapType === EMapType.SATURATED"
  class="btn map-type-switcher-btn"
  i18n-fmTooltip="@@S_MAP_HIGH_SATURATION"
  fmTooltip="Low Colour"
  a7s-id="live-map-options-low-colour">
  <span class="map-type-switcher__text"
    i18n="@@S_MAP_HIGH_SATURATION">Low Colour</span>
</button>
<button (click)="switchMapTypeClick(EMapType.HYBRID)"
  [class.map-type-switcher-btn--selected]="mapType === EMapType.HYBRID"
  class="btn map-type-switcher-btn"
  i18n-fmTooltip="@@S_SATELLITE"
  fmTooltip="Satellite"
  a7s-id="live-map-options-satellite">
  <span class="map-type-switcher__text"
    i18n="@@S_SATELLITE">Satellite</span>
</button>
